import { Autocomplete, TextField } from "@mui/material";
import { FC } from "react";

import { StationsBulkSelectAllPaper } from "./stations-bulk-select-all-paper";

const MAP_BULK_TAGS_LIMIT = 2;

interface IStationsBulkMultiSelectProps {
  label: string;
  options: number[];
  value: number[];
  onChange: (value: number[]) => void;
  getOptionLabel: (id: number) => string;
  isAllSelected: boolean;
  onToggleAll: () => void;
}

/** Station-ids multiselect used in the bulk-target panel, with a "Select all" popup toggle. */
export const StationsBulkMultiSelect: FC<IStationsBulkMultiSelectProps> = ({
  label,
  options,
  value,
  onChange,
  getOptionLabel,
  isAllSelected,
  onToggleAll,
}) => {
  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      limitTags={MAP_BULK_TAGS_LIMIT}
      options={options}
      value={value}
      onChange={(_event, newValue) => onChange(newValue as number[])}
      getOptionLabel={getOptionLabel}
      slots={{
        paper: paperProps => (
          <StationsBulkSelectAllPaper
            {...paperProps}
            checked={isAllSelected}
            onToggleAll={onToggleAll}
          />
        ),
      }}
      renderInput={params => <TextField {...params} label={label} />}
    />
  );
};
